/**
 * UI text for the SFG admin app, in Mongolian and English.
 *
 * Mongolian is the default and stays the reference wording. Add a key here, then read it with
 * the `t` function from useTranslation(). A missing key falls back to the Mongolian text, so a
 * partly translated screen still renders.
 */
const translations = {
    mn: {
        "lang.name": "Монгол",
        "lang.switch": "Хэл",

        // layout / sidebar
        "app.title": "STU Finance",
        "app.subtitle": "Админы хэсэг",
        "nav.transactionPlan": "Гүйлгээний төлөвлөгөө",
        "nav.transactionSchedule": "Гүйлгээний хуваарь",
        "nav.balance": "Баланс",
        "nav.statements": "Хуулга",
        "nav.institutions": "Байгууллагууд",
        "nav.users": "Хэрэглэгчид",
        "nav.logout": "Системээс гарах",
        "nav.setupImport": "Анхны өгөгдөл",

        // TEMPORARY setup importer
        "setup.title": "Анхны өгөгдөл оруулах",
        "setup.temporary": "Түр зуурын",
        "setup.subtitle": "Эцсийн Excel файл болон нэхэмжлэхийн ZIP-үүдийг нэг дор импортлоно. Энэ хэсэг зөвхөн анхны тохиргоонд зориулагдсан.",
        "setup.excelDrop": "Excel файлаа энд чирнэ үү",
        "setup.excelHint": "2-5-р хуудаснуудын гүйлгээний мөрүүдийг уншина",
        "setup.zipDrop": "Нэхэмжлэхийн ZIP файлуудаа энд чирнэ үү",
        "setup.zipHint": "Олон ZIP зэрэг сонгож болно. PDF нэрийн эхний код (S1, A12 ...) Excel-ийн № баганатай тааруулна",
        "setup.replaceExisting": "Хуучин өгөгдлийг устгаад дахин ачаалах",
        "setup.replaceHint": "Унтраавал одоо байгаа мөрүүд дээр нэмж импортлоно",
        "setup.requireInvoice": "Зөвхөн нэхэмжлэхтэй мөрийг импортлох",
        "setup.requireInvoiceHint": "Унтраавал нэхэмжлэхгүй мөрүүдийг бас импортлоно",
        "setup.skippedNoInvoice": "Нэхэмжлэхгүй тул алгассан мөр",
        "setup.stat.skippedNoInvoice": "Нэхэмжлэхгүй тул алгассан",
        "setup.col.skipped": "Алгассан",
        "setup.run": "Импорт эхлүүлэх",
        "setup.needExcel": "Excel файл сонгоно уу",
        "setup.done": "Импорт амжилттай дууслаа",
        "setup.failed": "Импорт амжилтгүй боллоо",
        "setup.perSheet": "Хуудас тус бүрээр",
        "setup.invalidRows": "Алдаатай мөрүүд",
        "setup.unmatchedPdfs": "Тохирохгүй PDF файлууд",
        "setup.ambiguous": "Давхардсан / тодорхойгүй тохирол",
        "setup.col.sheet": "Хуудас",
        "setup.col.rows": "Нийт мөр",
        "setup.col.imported": "Импортолсон",
        "setup.col.invalid": "Алдаатай",
        "setup.col.invoices": "Нэхэмжлэх",
        "setup.col.code": "Код",
        "setup.col.reason": "Шалтгаан",
        "setup.stat.totalRows": "Excel-ийн нийт мөр",
        "setup.stat.imported": "Импортолсон мөр",
        "setup.stat.invalid": "Алдаатай мөр",
        "setup.stat.pdfs": "ZIP доторх PDF",
        "setup.stat.matched": "Тохирсон нэхэмжлэх",
        "setup.stat.withoutInvoice": "Нэхэмжлэхгүй мөр",
        "setup.stat.unmatchedPdfs": "Тохирохгүй PDF",
        "setup.stat.ambiguous": "Тодорхойгүй тохирол",
        "setup.stat.deleted": "Устгасан хуучин мөр",

        // shared actions
        "action.refresh": "Сэргээх",
        "action.add": "Мэдээлэл нэмэх",
        "action.save": "Хадгалах",
        "action.clear": "Цэвэрлэх",
        "action.close": "Хаах",
        "action.download": "Татах",
        "action.view": "Харах",
        "action.upload": "Нэхэмжлэх",
        "action.replace": "Солих",
        "action.preview": "Preview",
        "action.removeFile": "Файл арилгах",
        "action.retry": "Дахин оролдох",
        "action.edit": "Засах",
        "action.delete": "Устгах",
        "action.cancel": "Болих",

        // transaction plan page
        "plan.title": "Гүйлгээний төлөвлөгөө",
        "plan.stat.total": "Нийт төлөвлөгөө",
        "plan.stat.withInvoice": "Нэхэмжлэхтэй",
        "plan.stat.filtered": "Шүүлтээр олдсон",
        "plan.empty": "Гүйлгээний төлөвлөгөө олдсонгүй",
        "plan.loadError": "Мэдээлэл ачаалахад алдаа гарлаа",

        // filters
        "filter.title": "Шүүлтүүр",
        "filter.totalRows": "Нийт мөр",
        "filter.search": "Sender / Beneficiary / Банк",
        "filter.dateFrom": "Эхлэх",
        "filter.dateTo": "Дуусах",

        // table columns
        "col.id": "ID",
        "col.sender": "Sender",
        "col.beneficiary": "Beneficiary",
        "col.beneficiaryBank": "Bene Bank",
        "col.currency": "Валют",
        "col.amount": "Дүн",
        "col.executionDate": "Гүйлгээний огноо",
        "col.source": "Эх сурвалж",
        "col.createdBy": "Бүртгэсэн",
        "col.invoice": "Нэхэмжлэх",
        "col.status": "Төлөв",
        "col.row": "Мөр",
        "col.errors": "Алдаа",
        "col.actions": "Үйлдэл",

        // values
        "source.excel": "Excel",
        "source.manual": "Гараар",
        "invoice.none": "Нэхэмжлэх байхгүй",
        "invoice.has": "Нэхэмжлэхтэй",
        "invoice.hasNot": "Нэхэмжлэхгүй",

        // invoice modal
        "invoice.modalTitle": "Нэхэмжлэх харах",
        "invoice.file": "Файл",
        "invoice.size": "Хэмжээ",
        "invoice.uploaded": "Хавсаргасан",
        "invoice.loading": "Нэхэмжлэх ачааллаж байна...",
        "invoice.empty": "Нэхэмжлэх байхгүй байна",
        "invoice.error": "Нэхэмжлэхийн алдаа",
        "invoice.loadFailed": "Нэхэмжлэхийг ачаалж чадсангүй",
        "invoice.downloaded": "Нэхэмжлэх татагдлаа",
        "invoice.downloadFailed": "Нэхэмжлэх татахад алдаа гарлаа",
        "invoice.uploadFailed": "Нэхэмжлэх хавсаргахад алдаа гарлаа",
        "invoice.uploaded.ok": "Нэхэмжлэх хавсаргагдлаа",
        "invoice.replaced.ok": "Нэхэмжлэх солигдлоо",
        "invoice.noPermission": "Нэхэмжлэх хавсаргах эрхгүй байна",

        // edit / delete (admin)
        "edit.modalTitle": "Гүйлгээний төлөвлөгөө засах",
        "edit.hint": "Мөрийн мэдээллийг засна. unq_id өөрчлөгдөхгүй.",
        "edit.saved": "Гүйлгээний төлөвлөгөө шинэчлэгдлээ",
        "edit.saveFailed": "Засварыг хадгалахад алдаа гарлаа",
        "edit.saveError": "Засварын алдаа",
        "delete.confirmTitle": "Энэ мөрийг устгах уу?",
        "delete.confirmBody": "Устгасан мөр болон түүний нэхэмжлэхийг сэргээх боломжгүй.",
        "delete.done": "Гүйлгээний төлөвлөгөө устгагдлаа",
        "delete.failed": "Устгахад алдаа гарлаа",
        "delete.noPermission": "Устгах эрхгүй байна",

        // add modal
        "add.modalTitle": "Гүйлгээний төлөвлөгөө нэмэх",
        "add.tab.excel": "Excel импорт",
        "add.tab.manual": "Гараар нэмэх",

        // excel import
        "excel.title": "Excel файл оруулах",
        "excel.columns":
            "Багана: № | Sender | Beneficiary | Bene Bank | Currency / Валюта | Amount / Сумма | Execution date / Дата исполнения",
        "excel.drop": "Excel файлаа энд чирж оруулах эсвэл дарж сонгоно уу",
        "excel.hint": "Upload хийсний дараа мөр бүрийн шалгалтын үр дүн preview дээр харагдана",
        "excel.noFile": "Файл сонгоогүй",
        "excel.reading": "Уншиж байна...",
        "excel.importable": "Импортлох",
        "excel.duplicate": "Давхардсан",
        "excel.duplicateHint": "импортлогдоно",
        "excel.invalid": "Алдаатай",
        "excel.previewTitle": "Excel мөрүүдийг шалгах",
        "excel.confirm": "Би мөрүүдийг шалгасан, импортлож болно",
        "excel.import": "Импортлох",
        "excel.file": "Файл",
        "excel.totalRows": "Нийт мөр",
        "excel.ready": "Импортлох боломжтой мөрүүд бэлэн",
        "excel.notReady": "Импортлох боломжтой мөр алга",
        "excel.fileError": "Файлын алдаа",
        "excel.error": "Excel алдаа",
        "excel.readFailed": "Excel уншихад алдаа гарлаа",
        "excel.importFailed": "Импорт амжилтгүй боллоо",
        "excel.importOk": "Импорт амжилттай",
        "excel.selectFile": "Excel файл сонгоно уу",
        "excel.nothingToImport": "Импортлох боломжтой мөр алга байна",
        "excel.confirmFirst": "Мөрүүдийг шалгаснаа баталгаажуулна уу",
        "excel.noRows": "Мөр олдсонгүй",
        "excel.status.ok": "Импортлох боломжтой",
        "excel.status.dupFile": "Файл дотроо давхардсан (импортлоно)",
        "excel.status.dupDb": "Өмнө бүртгэгдсэн (импортлоно)",
        "excel.status.invalid": "Алдаатай",

        // manual form
        "manual.title": "Гараар нэмэх",
        "manual.hint": "Excel-тэй ижил бүтэцтэй. unq_id нь мөрийн агуулгаас автоматаар үүснэ.",
        "manual.saved": "Гүйлгээний төлөвлөгөө хадгалагдлаа",
        "manual.saveFailed": "Хадгалахад алдаа гарлаа",
        "manual.saveError": "Хадгалах алдаа",
        "manual.ph.sender": "Илгээгч байгууллага",
        "manual.ph.beneficiary": "Хүлээн авагч байгууллага",
        "manual.ph.beneficiaryBank": "Хүлээн авагчийн банк",
        "manual.ph.date": "Огноо сонгох",
        "req.sender": "Sender заавал бөглөнө",
        "req.beneficiary": "Beneficiary заавал бөглөнө",
        "req.currency": "Валют заавал сонгоно",
        "req.amount": "Дүн заавал бөглөнө",
        "req.amountPositive": "Дүн 0-ээс их байх ёстой",
        "req.date": "Огноо заавал сонгоно",
        "req.max50": "50 тэмдэгтээс их байж болохгүй",
        "req.max255": "255 тэмдэгтээс их байж болохгүй",

        // login
        "login.title": "SFG системд нэвтрэх",
        "login.username": "Нэвтрэх нэр",
        "login.password": "Нууц үг",
        "login.submit": "Нэвтрэх",
        "login.failed": "Нэвтрэхэд алдаа гарлаа",
    },

    en: {
        "lang.name": "English",
        "lang.switch": "Language",

        "app.title": "STU Finance",
        "app.subtitle": "Admin area",
        "nav.transactionPlan": "Transaction Plan",
        "nav.transactionSchedule": "Transaction Schedule",
        "nav.balance": "Balance",
        "nav.statements": "Statements",
        "nav.institutions": "Institutions",
        "nav.users": "Users",
        "nav.logout": "Sign out",
        "nav.setupImport": "Initial data",

        // TEMPORARY setup importer
        "setup.title": "Initial data import",
        "setup.temporary": "Temporary",
        "setup.subtitle": "Loads the final Excel workbook together with the invoice ZIPs in one run. This section exists only for the initial site setup.",
        "setup.excelDrop": "Drop the Excel file here",
        "setup.excelHint": "Reads the transaction rows from sheets 2-5",
        "setup.zipDrop": "Drop the invoice ZIPs here",
        "setup.zipHint": "Several ZIPs can be selected at once. Matches the leading code of each PDF name (S1, A12 ...) to the Excel number column",
        "setup.replaceExisting": "Wipe existing data and reload",
        "setup.replaceHint": "Turn off to append to the rows already in the table",
        "setup.requireInvoice": "Only import rows that have an invoice",
        "setup.requireInvoiceHint": "Turn off to also import rows without an invoice",
        "setup.skippedNoInvoice": "Rows skipped for having no invoice",
        "setup.stat.skippedNoInvoice": "Skipped, no invoice",
        "setup.col.skipped": "Skipped",
        "setup.run": "Run import",
        "setup.needExcel": "Choose an Excel file",
        "setup.done": "Import finished",
        "setup.failed": "Import failed",
        "setup.perSheet": "Per sheet",
        "setup.invalidRows": "Invalid rows",
        "setup.unmatchedPdfs": "Unmatched PDF files",
        "setup.ambiguous": "Duplicate / ambiguous matches",
        "setup.col.sheet": "Sheet",
        "setup.col.rows": "Rows",
        "setup.col.imported": "Imported",
        "setup.col.invalid": "Invalid",
        "setup.col.invoices": "Invoices",
        "setup.col.code": "Code",
        "setup.col.reason": "Reason",
        "setup.stat.totalRows": "Excel rows found",
        "setup.stat.imported": "Rows imported",
        "setup.stat.invalid": "Invalid rows",
        "setup.stat.pdfs": "PDFs in the ZIPs",
        "setup.stat.matched": "Invoices matched",
        "setup.stat.withoutInvoice": "Rows without invoice",
        "setup.stat.unmatchedPdfs": "Unmatched PDFs",
        "setup.stat.ambiguous": "Ambiguous matches",
        "setup.stat.deleted": "Old rows deleted",

        "action.refresh": "Refresh",
        "action.add": "Add data",
        "action.save": "Save",
        "action.clear": "Clear",
        "action.close": "Close",
        "action.download": "Download",
        "action.view": "View",
        "action.upload": "Invoice",
        "action.replace": "Replace",
        "action.preview": "Preview",
        "action.removeFile": "Remove file",
        "action.retry": "Try again",
        "action.edit": "Edit",
        "action.delete": "Delete",
        "action.cancel": "Cancel",

        "plan.title": "Transaction Plan",
        "plan.stat.total": "Total plans",
        "plan.stat.withInvoice": "With invoice",
        "plan.stat.filtered": "Matching filter",
        "plan.empty": "No transaction plans found",
        "plan.loadError": "Failed to load the data",

        "filter.title": "Filters",
        "filter.totalRows": "Total rows",
        "filter.search": "Sender / Beneficiary / Bank",
        "filter.dateFrom": "From",
        "filter.dateTo": "To",

        "col.id": "ID",
        "col.sender": "Sender",
        "col.beneficiary": "Beneficiary",
        "col.beneficiaryBank": "Bene Bank",
        "col.currency": "Currency",
        "col.amount": "Amount",
        "col.executionDate": "Transaction date",
        "col.source": "Source",
        "col.createdBy": "Created by",
        "col.invoice": "Invoice",
        "col.status": "Status",
        "col.row": "Row",
        "col.errors": "Errors",
        "col.actions": "Actions",

        "source.excel": "Excel",
        "source.manual": "Manual",
        "invoice.none": "No invoice",
        "invoice.has": "With invoice",
        "invoice.hasNot": "Without invoice",

        "invoice.modalTitle": "View invoice",
        "invoice.file": "File",
        "invoice.size": "Size",
        "invoice.uploaded": "Uploaded",
        "invoice.loading": "Loading the invoice...",
        "invoice.empty": "No invoice attached",
        "invoice.error": "Invoice error",
        "invoice.loadFailed": "Could not load the invoice",
        "invoice.downloaded": "Invoice downloaded",
        "invoice.downloadFailed": "Failed to download the invoice",
        "invoice.uploadFailed": "Failed to attach the invoice",
        "invoice.uploaded.ok": "Invoice attached",
        "invoice.replaced.ok": "Invoice replaced",
        "invoice.noPermission": "You are not allowed to attach invoices",

        "edit.modalTitle": "Edit transaction plan",
        "edit.hint": "Update the row's details. The unq_id stays unchanged.",
        "edit.saved": "Transaction plan updated",
        "edit.saveFailed": "Failed to save the changes",
        "edit.saveError": "Update error",
        "delete.confirmTitle": "Delete this row?",
        "delete.confirmBody": "The row and its invoice cannot be recovered.",
        "delete.done": "Transaction plan deleted",
        "delete.failed": "Failed to delete",
        "delete.noPermission": "You are not allowed to delete",

        "add.modalTitle": "Add a transaction plan",
        "add.tab.excel": "Excel import",
        "add.tab.manual": "Manual entry",

        "excel.title": "Upload an Excel file",
        "excel.columns":
            "Columns: № | Sender | Beneficiary | Bene Bank | Currency / Валюта | Amount / Сумма | Execution date / Дата исполнения",
        "excel.drop": "Drag an Excel file here, or click to choose one",
        "excel.hint": "After uploading, every parsed row is shown with its validation result",
        "excel.noFile": "No file selected",
        "excel.reading": "Reading...",
        "excel.importable": "Importable",
        "excel.duplicate": "Duplicates",
        "excel.duplicateHint": "imported anyway",
        "excel.invalid": "Invalid",
        "excel.previewTitle": "Review the Excel rows",
        "excel.confirm": "I have reviewed the rows and they can be imported",
        "excel.import": "Import",
        "excel.file": "File",
        "excel.totalRows": "Total rows",
        "excel.ready": "Rows are ready to import",
        "excel.notReady": "Nothing can be imported",
        "excel.fileError": "File errors",
        "excel.error": "Excel error",
        "excel.readFailed": "Failed to read the Excel file",
        "excel.importFailed": "Import failed",
        "excel.importOk": "Import finished",
        "excel.selectFile": "Choose an Excel file",
        "excel.nothingToImport": "There are no importable rows",
        "excel.confirmFirst": "Please confirm you reviewed the rows",
        "excel.noRows": "No rows found",
        "excel.status.ok": "Importable",
        "excel.status.dupFile": "Duplicate in file (still imported)",
        "excel.status.dupDb": "Already in database (still imported)",
        "excel.status.invalid": "Invalid",

        "manual.title": "Manual entry",
        "manual.hint":
            "Same structure as the Excel file. The unq_id is generated from the row content.",
        "manual.saved": "Transaction plan saved",
        "manual.saveFailed": "Failed to save",
        "manual.saveError": "Save error",
        "manual.ph.sender": "Sending company",
        "manual.ph.beneficiary": "Receiving company",
        "manual.ph.beneficiaryBank": "Beneficiary bank",
        "manual.ph.date": "Pick a date",
        "req.sender": "Sender is required",
        "req.beneficiary": "Beneficiary is required",
        "req.currency": "Currency is required",
        "req.amount": "Amount is required",
        "req.amountPositive": "Amount must be greater than 0",
        "req.date": "Date is required",
        "req.max50": "Must be at most 50 characters",
        "req.max255": "Must be at most 255 characters",

        "login.title": "SFG system login",
        "login.username": "Username",
        "login.password": "Password",
        "login.submit": "Sign in",
        "login.failed": "Login failed",
    },
};

export default translations;
